module.exports = __webpack_public_path__ + "static/media/mitarbeiter.a5d0acb6.jpg";